import * as React from "react"

const SvgCouponTop = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={451}
    height={279}
    viewBox="0 0 451 279"
    {...props}
  >
    <path
      d="M415 279H36a35.752 35.752 0 0 0-10.556-25.444A35.759 35.759 0 0 0 0 243V0h19.366A24.041 24.041 0 0 0 42 16 24.041 24.041 0 0 0 64.634 0h15.732A24.04 24.04 0 0 0 103 16a24.041 24.041 0 0 0 22.634-16h15.732A24.04 24.04 0 0 0 164 16a24.041 24.041 0 0 0 22.634-16h16.731A24.041 24.041 0 0 0 226 16a24.041 24.041 0 0 0 22.634-16h15.731A24.041 24.041 0 0 0 287 16a24.042 24.042 0 0 0 22.635-16h15.731A24.041 24.041 0 0 0 348 16a24.041 24.041 0 0 0 22.634-16h15.732A24.04 24.04 0 0 0 409 16a24.041 24.041 0 0 0 22.634-16H451v243a36.041 36.041 0 0 0-36 36Z"
      fill="#fff"
    />
  </svg>
)

export default SvgCouponTop
